export default {
    'ERROR-ADMIN-SIGNUP-CHECK': {
        'NO-SIGN-UP-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Aucune inscription trouvée.",
                en: "No sign-up found.",
            },
        },
        'USER-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: "Un admin existe déjà avec cet email.",
                en: "An admin already exists with this email.",
            },
        },
    },
    'ERROR-ADMIN-SIGNUP-INITIALIZED': {
        'ADMIN-DATA-INVALID': {
            actionType: 'toast',
            message: {
                fr: "Données admin invalides.",
                en: "Invalid admin data.",
            },
        },
        'ADMIN-DATA-INCOMPLETE': {
            actionType: 'toast',
            message: {
                fr: "Données admin incomplètes.",
                en: "Incomplete admin data.",
            },
        },
        'EMAIL-INVALID': {
            actionType: 'toast',
            message: {
                fr: "Email invalide.",
                en: "Invalid email.",
            },
        },
        'USER-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: "Un admin existe déjà avec cet email.",
                en: "An admin already exists with this email.",
            },
        },
    },
    'ERROR-ADMIN-SIGNUP-ORGANIZATION': {
        'ORGANIZATION-DATA-INVALID': {
            actionType: 'toast',
            message: {
                fr: "Données de l'organisation invalides.",
                en: "Invalid organization data.",
            },
        },
        'ORGANIZATION-DATA-INCOMPLETE': {
            actionType: 'toast',
            message: {
                fr: "Informations manquantes pour l'organisation.",
                en: "Missing organization information.",
            },
        },
        'UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "UUID invalide.",
                en: "Invalid UUID.",
            },
        },
        'NO-SIGN-UP-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Inscription introuvable.",
                en: "Sign-up not found.",
            },
            redirectPath: '/',
        },
        'NEXT-STEP-LESS-THAN-1': {
            actionType: 'toast',
            message: {
                fr: "Étape précédente non complétée.",
                en: "Previous step not completed.",
            },
        },
        'IS-ONBOARDING-COMPLETED': {
            actionType: 'toast',
            message: {
                fr: "Onboarding déjà complété.",
                en: "Onboarding already completed.",
            },
        },
    },
    'ERROR-ADMIN-SIGNUP-TARGET': {
        'UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "UUID invalide.",
                en: "Invalid UUID.",
            },
        },
        'TARGETS-NOT-ARRAY': {
            actionType: 'toast',
            message: {
                fr: "Les cibles doivent être un tableau.",
                en: "Targets must be an array.",
            },
        },
        'NO-SIGN-UP-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Inscription introuvable.",
                en: "Sign-up not found.",
            },
            redirectPath: '/',
        },
        'NEXT-STEP-LESS-THAN-2': {
            actionType: 'toast',
            message: {
                fr: "Étape précédente non complétée.",
                en: "Previous step not completed.",
            },
        },
        'IS-ONBOARDING-COMPLETED': {
            actionType: 'toast',
            message: {
                fr: "Onboarding déjà complété.",
                en: "Onboarding already completed.",
            },
        },
    },
    'ERROR-ADMIN-SIGNUP-INTEGRATIONS': {
        'UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "UUID invalide.",
                en: "Invalid UUID.",
            },
        },
        'INTEGRATIONS-NOT-ARRAY': {
            actionType: 'toast',
            message: {
                fr: "Les intégrations doivent être un tableau.",
                en: "Integrations must be an array.",
            },
        },
        'OTHER-INTEGRATION-EXPLICATION-MISSING': {
            actionType: 'toast',
            message: {
                fr: "Merci d'indiquer la nature de l'intégration.",
                en: "Please explain the integration.",
            },
        },
        'NO-SIGN-UP-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Inscription introuvable.",
                en: "Sign-up not found.",
            },
            redirectPath: '/',
        },
        'NEXT-STEP-LESS-THAN-3': {
            actionType: 'toast',
            message: {
                fr: "Étape précédente non complétée.",
                en: "Previous step not completed.",
            },
        },
        'IS-ONBOARDING-COMPLETED': {
            actionType: 'toast',
            message: {
                fr: "Onboarding déjà complété.",
                en: "Onboarding already completed.",
            },
        },
    },
    'ERROR-ADMIN-SIGNUP-AMBASSADORS': {
        'UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "UUID invalide.",
                en: "Invalid UUID.",
            },
        },
        'NO-SIGN-UP-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Inscription introuvable.",
                en: "Sign-up not found.",
            },
            redirectPath: '/',
        },
        'NEXT-STEP-LESS-THAN-4': {
            actionType: 'toast',
            message: {
                fr: "Étape précédente non complétée.",
                en: "Previous step not completed.",
            },
        },
        'IS-ONBOARDING-COMPLETED': {
            actionType: 'toast',
            message: {
                fr: "Onboarding déjà complété.",
                en: "Onboarding already completed.",
            },
        },
        'AMBASSADOR-INFO-MISSING': {
            actionType: 'toast',
            message: {
                fr: "Informations incomplètes pour un ambassadeur.",
                en: "Ambassador information incomplete.",
            },
        },
    },
    'ERROR-ADMIN-SIGNUP-CRITERIA': {
        'UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "UUID invalide.",
                en: "Invalid UUID.",
            },
        },
        'CRITERIA-INCOMPLETE': {
            actionType: 'toast',
            message: {
                fr: "Critères forts manquants.",
                en: "Strong criteria missing.",
            },
        },
        'SIGNUP-ADMIN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Inscription introuvable.",
                en: "Sign-up not found.",
            },
            redirectPath: '/',
        },
        'NEXT-STEP-LESS-THAN-5': {
            actionType: 'toast',
            message: {
                fr: "Étape précédente non complétée.",
                en: "Previous step not completed.",
            },
        },
        'ONBOARDING-COMPLETED': {
            actionType: 'toast',
            message: {
                fr: "Onboarding déjà complété.",
                en: "Onboarding already completed.",
            },
        },
        'ONBOARDING-CONFIRMED': {
            actionType: 'toast',
            message: {
                fr: "Onboarding déjà confirmé.",
                en: "Onboarding already confirmed.",
            },
        },
        'OTHER-STRONG-CRITERIA-LABEL-MISSING': {
            actionType: 'toast',
            message: {
                fr: "Merci d'indiquer un libellé pour le critère fort 'Autre'.",
                en: "Please provide a label for the 'Other' strong criteria.",
            },
        },
        'DEFAULT-CAMPAIGN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Campagne par défaut introuvable.",
                en: "Default campaign not found.",
            },
            redirectPath: '/',
        },
        'NO-STRONG-CRITERIA-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Critère fort introuvable pour cette campagne.",
                en: "Strong criteria not found for this campaign.",
            },
        },
    },
    'ERROR-ADMIN-SIGNUP-BOOKING': {
        'UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "UUID invalide.",
                en: "Invalid UUID.",
            },
        },
        'SIGNUP-ADMIN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Inscription introuvable.",
                en: "Sign-up not found.",
            },
            redirectPath: '/',
        },
        'NEXT-STEP-LESS-THAN-6': {
            actionType: 'toast',
            message: {
                fr: "Étape précédente non complétée.",
                en: "Previous step not completed.",
            },
        },
    },
    'ERROR-ADMIN-SIGNUP-RESTART': {
        'UUID-INVALID': {
            actionType: 'toast',
            message: {
                fr: "UUID invalide.",
                en: "Invalid UUID.",
            },
        },
        'SIGNUPADMIN-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Inscription introuvable.",
                en: "Sign-up not found.",
            },
            redirectPath: '/',
        },
        'ONBOARDING-COMPLETED': {
            actionType: 'toast',
            message: {
                fr: "Onboarding déjà complété.",
                en: "Onboarding already completed.",
            },
        },
        'INVALID-NEXTSTEP': {
            actionType: 'toast',
            message: {
                fr: "Étape actuelle invalide pour restart.",
                en: "Invalid step to restart.",
            },
        },
        'ORGANIZATION-ID-EXISTS': {
            actionType: 'toast',
            message: {
                fr: "Organisation déjà créée, impossible de restart.",
                en: "Organization already created, cannot restart.",
            },
        },
    },
};
